<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading1 || pageLoading2 || pageLoading3" class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
@if (navbar.userAccess?.Closure_Report=='Full' || navbar.userAccess?.Closure_Report=='Readonly'){
<div class="row">
	<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
		<div class="card">
			<div class="card-header bg-theme mb-0">
				<h5 class="card-title text-white mb-0">
					Details
				</h5>
			</div>
			<div class="card-body pt-0">
				<form [formGroup]="moduleForm" (ngSubmit)="saveClosureReport_A()" #modform="ngForm">
					<div class="row mb-2 mt-1">
						<div class="col-3">
							@if (navbar.userAccess?.Closure_Report=='Full'){
							<button type="submit" class="btn btn-sm btn-success me-1"
								[disabled]="saveLoader || !modform.dirty">
								<fa-icon *ngIf="!saveLoader" [icon]="['fas', 'save']"></fa-icon>
								<fa-icon *ngIf="saveLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								Save
							</button>
							}
							<a type="button" class="btn btn-sm btn-secondary"
								[routerLink]="['/app/appt-details','no',uId,'empty']">
								Cancel
							</a>
						</div>
						<div class="col-9 text-end">
							<mat-checkbox [color]="'primary'" [(ngModel)]="closure_report_sent"
								[ngModelOptions]="{standalone: true}" (change)="reportSentChange()"
								id="closure_report_sent" class="me-2"
								[disabled]="navbar.userAccess?.Closure_Report!='Full'">
								Report sent
								@if (rep_sent_loader) {
								<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
								}
							</mat-checkbox>
							@if(closure_report_sent){
							<span class="small">
								Updated by
								<strong>
									{{caseDetails?.closure_report_sent_by}}
								</strong>
								at
								<strong>
									{{caseDetails?.closure_report_sent_date}}
								</strong>
							</span>
							}
						</div>
					</div>
					<ng-container *ngIf="reportDetails">
						<div class="row mb-2">
							<div class="col-md-6">
								<div class="input-group">
									<div class="form-floating">
										<input [ngClass]="{'is-invalid':showError('date')}" placeholder=""
											class="form-control" formControlName="date" ngbDatepicker id="date"
											#date="ngbDatepicker" [minDate]="minDate" />
										<label for="date">Date</label>
									</div>
									<button class="btn btn-outline-secondary" (click)="date.toggle()" type="button">
										<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
									</button>
								</div>
								<p *ngIf="showError('date')" class="text-danger">
									<span *ngIf="f.date.errors?.required">
										Required
									</span>
								</p>
							</div>
							<div class="col-md-6">
								<div class="form-floating">
									<input [disabled]="true" placeholder="" id="case_id"
										[value]="reportDetails.basic_details.case_id" class="form-control" />
									<label for="case_id">Case Id</label>
								</div>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-6">
								<div class="form-floating">
									<input [disabled]="true" placeholder="" id="patient_name"
										[value]="reportDetails.basic_details.name" class="form-control" />
									<label for="patient_name">Patient Name</label>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-floating">
									<input [disabled]="true" placeholder="" id="rank"
										[value]="reportDetails.basic_details.rank?.rank" class="form-control" />
									<label for="rank">Rank</label>
								</div>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-6">
								<div class="form-floating">
									<input [disabled]="true" placeholder="" id="vessel"
										[value]="reportDetails.basic_details.vessel?.vessel_name"
										class="form-control" />
									<label for="vessel">Vessel</label>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-floating">
									<input [disabled]="true" placeholder="" id="company"
										[value]="reportDetails.basic_details.company?.com_name" class="form-control" />
									<label for="company">Company</label>
								</div>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-4">
								<div class="form-floating">
									<input [ngClass]="{'is-invalid':showError('ref_by')}" placeholder=""
										formControlName="ref_by" id="ref_by" class="form-control" />
									<label for="ref_by">Ref. By</label>
								</div>
								<p *ngIf="showError('ref_by')" class="text-danger mb-0">
									<span *ngIf="f.ref_by.errors?.required">
										Required
									</span>
								</p>
							</div>
							<div class="col-md-4">
								<div class="form-floating">
									<input [ngClass]="{'is-invalid':showError('ref_by_contact')}" placeholder=""
										formControlName="ref_by_contact" id="ref_by_contact" class="form-control" />
									<label for="ref_by_contact">Ref. By Contact</label>
								</div>
								<p *ngIf="showError('ref_by_contact')" class="text-danger mb-0">
									<span *ngIf="f.ref_by_contact.errors?.required">
										Required
									</span>
								</p>
							</div>
							<div class="col-md-4">
								<div class="form-floating">
									<input [ngClass]="{'is-invalid':showError('ref_by_email')}" placeholder=""
										formControlName="ref_by_email" id="ref_by_email" class="form-control" />
									<label for="ref_by_email">Ref. By Email</label>
								</div>
								<p *ngIf="showError('ref_by_email')" class="text-danger mb-0">
									<span *ngIf="f.ref_by_email.errors?.required">
										Required
									</span>
									<span *ngIf="f.ref_by_email.errors?.pattern">
										Invalid
									</span>
								</p>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-4">
								<div class="form-floating">
									<input [ngClass]="{'is-invalid':showError('poc')}" placeholder=""
										formControlName="poc" id="poc" class="form-control" />
									<label for="poc">POC</label>
								</div>
								<p *ngIf="showError('poc')" class="text-danger mb-0">
									<span *ngIf="f.poc.errors?.required">
										Required
									</span>
								</p>
							</div>
							<div class="col-md-4">
								<div class="form-floating">
									<input [ngClass]="{'is-invalid':showError('poc_contact')}" placeholder=""
										formControlName="poc_contact" id="poc_contact" class="form-control" />
									<label for="poc_contact">POC Contact</label>
								</div>
								<p *ngIf="showError('poc_contact')" class="text-danger mb-0">
									<span *ngIf="f.poc_contact.errors?.required">
										Required
									</span>
								</p>
							</div>
							<div class="col-md-4">
								<div class="form-floating">
									<input [ngClass]="{'is-invalid':showError('poc_email')}" placeholder=""
										formControlName="poc_email" id="poc_email" class="form-control" />
									<label for="poc_email">POC Email</label>
								</div>
								<p *ngIf="showError('poc_email')" class="text-danger mb-0">
									<span *ngIf="f.poc_email.errors?.required">
										Required
									</span>
									<span *ngIf="f.poc_email.errors?.pattern">
										Invalid
									</span>
								</p>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-12">
								<label class="form-label">MEDICAL HISTORY:</label>
								<quill-editor id="medical_history" formControlName="medical_history"
									[modules]="quillConfig" [placeholder]="'Text'"></quill-editor>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-12">
								<label class="form-label">PRELIMINARY DIAGNOSIS:</label>
								<quill-editor id="preliminary_diagnosis" formControlName="preliminary_diagnosis"
									[modules]="quillConfig" [placeholder]="'Text'"></quill-editor>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-12">
								<label class="form-label">KEY EVALUATIONS:</label>
								<table class="table table-bordered">
									<thead>
										<tr>
											<!-- <th style="width: 30%;">Date</th> -->
											<th style="width: 50%;">Evaluation</th>
											<th style="width: 50%;">Notes</th>
											<!-- <th style="width: 5%;"></th> -->
										</tr>
									</thead>
									<tbody>
										<tr formArrayName="key_evaluations"
											*ngFor="let creds of get_key_evaluations.controls; let i = index">
											<ng-container [formGroupName]="i">
												<!-- <td>
													<div class="input-group">
														<input class="form-control"
															[ngClass]="{'is-invalid':showErrorKeyEval(i,'date')}"
															placeholder="" formControlName="date" ngbDatepicker
															id="date{{i}}" #date="ngbDatepicker" [minDate]="minDate"
															[container]="'body'" />
														<button class="btn btn-outline-secondary"
															(click)="date.toggle()" type="button">
															<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
														</button>
													</div>
													<p *ngIf="showErrorKeyEval(i,'date')" class="text-danger">
														<span *ngIf="creds.get('date')?.errors?.required">
															Required
														</span>
														<span *ngIf="creds.get('date')?.errors?.ngbDate">
															Invalid
														</span>
													</p>
													{{creds.get('date')?.value}}
												</td> -->
												<td>
													<!-- <input class="form-control"
														[ngClass]="{'is-invalid':showErrorKeyEval(i,'evaluation')}"
														formControlName="evaluation" id="evaluation{{i}}" />
													<p *ngIf="showErrorKeyEval(i,'evaluation')" class="text-danger">
														<span *ngIf="creds.get('evaluation')?.errors?.required">
															Required
														</span>
													</p> -->
													{{creds.get('evaluation')?.value}}
												</td>
												<td>
													<!-- <input class="form-control"
														[ngClass]="{'is-invalid':showErrorKeyEval(i,'notes')}"
														formControlName="notes" id="notes{{i}}" />
													<p *ngIf="showErrorKeyEval(i,'notes')" class="text-danger">
														<span *ngIf="creds.get('notes')?.errors?.required">
															Required
														</span>
													</p> -->
													{{creds.get('notes')?.value}}
												</td>
												<!-- <td>
													<button type="button" (click)="delete_key_evaluations(i)"
														class="btn btn-sm btn-danger" matTooltip="Remove">
														<fa-icon [icon]="['fas', 'times']"></fa-icon>
													</button>
												</td> -->
											</ng-container>
										</tr>
										<!-- <tr>
											<td colspan="4" class="text-center">
												<button type="button" (click)="add_key_evaluations()"
													class="btn btn-sm btn-primary me-1">
													<fa-icon [icon]="['fas', 'plus']"></fa-icon>
													Add
												</button>
											</td>
										</tr> -->
									</tbody>
								</table>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-12">
								<label class="form-label">TREATMENT AND FOLLOW-UP:</label>
								<table class="table table-bordered">
									<thead>
										<tr>
											<th style="width: 30%;">TREATING DR.</th>
											<th style="width: 25%;">SPECIALIST</th>
											<th style="width: 25%;">CLINIC NAME</th>
											<th style="width: 20%;">CITY</th>
											<!-- <th style="width: 5%;"></th> -->
										</tr>
									</thead>
									<tbody>
										<tr formArrayName="treatments"
											*ngFor="let creds of get_treatments.controls; let i = index">
											<ng-container [formGroupName]="i">
												<td>
													<!-- <input class="form-control"
														[ngClass]="{'is-invalid':showErrorTreat(i,'treating_dr')}"
														formControlName="treating_dr" id="treating_dr{{i}}" />
													<p *ngIf="showErrorTreat(i,'treating_dr')" class="text-danger">
														<span *ngIf="creds.get('treating_dr')?.errors?.required">
															Required
														</span>
													</p> -->
													{{creds.get('treating_dr')?.value}}
												</td>
												<td>
													<!-- <input class="form-control"
														[ngClass]="{'is-invalid':showErrorTreat(i,'specialist')}"
														formControlName="specialist" id="specialist{{i}}" />
													<p *ngIf="showErrorTreat(i,'specialist')" class="text-danger">
														<span *ngIf="creds.get('specialist')?.errors?.required">
															Required
														</span>
													</p> -->
													{{creds.get('specialist')?.value}}
												</td>
												<td>
													<!-- <input class="form-control"
														[ngClass]="{'is-invalid':showErrorTreat(i,'clinic_name')}"
														formControlName="clinic_name" id="clinic_name{{i}}" />
													<p *ngIf="showErrorTreat(i,'clinic_name')" class="text-danger">
														<span *ngIf="creds.get('clinic_name')?.errors?.required">
															Required
														</span>
													</p> -->
													{{creds.get('clinic_name')?.value}}
												</td>
												<td>
													<!-- <input class="form-control"
														[ngClass]="{'is-invalid':showErrorTreat(i,'city')}"
														formControlName="city" id="city{{i}}" />
													<p *ngIf="showErrorTreat(i,'city')" class="text-danger">
														<span *ngIf="creds.get('city')?.errors?.required">
															Required
														</span>
													</p> -->
													{{creds.get('city')?.value}}
												</td>
												<!-- <td>
													<button type="button" (click)="delete_treatments(i)"
														class="btn btn-sm btn-danger" matTooltip="Remove">
														<fa-icon [icon]="['fas', 'times']"></fa-icon>
													</button>
												</td> -->
											</ng-container>
										</tr>
										<!-- <tr>
											<td colspan="5" class="text-center">
												<button type="button" (click)="add_treatments()"
													class="btn btn-sm btn-primary me-1">
													<fa-icon [icon]="['fas', 'plus']"></fa-icon>
													Add
												</button>
											</td>
										</tr> -->
									</tbody>
								</table>
							</div>
						</div>
						<div class="row mb-2" *ngIf="get_appointments.length">
							<div class="col-md-12">
								<label class="form-label">Notes:</label>
							</div>
						</div>
						<div class="row mb-2" formArrayName="appointments"
							*ngFor="let appts of get_appointments.controls; let i = index">
							<ng-container [formGroupName]="i">
								<div class="col-md-12">
									<label class="form-label underline">
										{{appts.get('follow_up_date')?.value}}:
									</label>
									<quill-editor id="opd_notes{{i}}" formControlName="opd_notes"
										[modules]="quillConfig" [placeholder]="'Text'"></quill-editor>
									<p *ngIf="showErrorAppt(i,'opd_notes')" class="text-danger">
										<span *ngIf="appts.get('opd_notes')?.errors?.required">
											Required
										</span>
									</p>
								</div>
							</ng-container>
						</div>
						<div class="row mb-2" *ngIf="caseDetails?.status==2">
							<div class="col-md-12">
								<label class="form-label">CLOSURE NOTES / MEDICAL OPINION:</label>
								<quill-editor id="closure_notes" formControlName="closure_notes" [modules]="quillConfig"
									[placeholder]="'Text'"></quill-editor>
							</div>
						</div>
					</ng-container>
					<div class="row mb-2">
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<ng-select [ngClass]="{'is-invalid':showError('doctor_1_id')}" [items]="doctortList"
								bindLabel="name" bindValue="id" [clearable]="true" id="doctor_1_id"
								formControlName="doctor_1_id" placeholder="Doctor 1*" [appearance]="'outline'">
							</ng-select>
							<p *ngIf="showError('doctor_1_id')" class="text-danger">
								<span *ngIf="f.doctor_1_id.errors?.required">
									Required
								</span>
							</p>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<ng-select [ngClass]="{'is-invalid':showError('doctor_2_id')}" [items]="doctortList"
								bindLabel="name" bindValue="id" [clearable]="true" id="doctor_2_id"
								formControlName="doctor_2_id" placeholder="Doctor 2*" [appearance]="'outline'">
							</ng-select>
							<p *ngIf="showError('doctor_2_id')" class="text-danger">
								<span *ngIf="f.doctor_2_id.errors?.required">
									Required
								</span>
							</p>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							@if (navbar.userAccess?.Closure_Report=='Full'){
							<button type="submit" class="btn btn-sm btn-success me-1"
								[disabled]="saveLoader || !modform.dirty">
								<fa-icon *ngIf="!saveLoader" [icon]="['fas', 'save']"></fa-icon>
								<fa-icon *ngIf="saveLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								Save
							</button>
							}
							<a type="button" class="btn btn-sm btn-secondary"
								[routerLink]="['/app/appt-details','no',uId,'empty']">
								Cancel
							</a>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
		<div class="card">
			<div class="card-header bg-theme mb-0">
				<h5 class="card-title text-white mb-0">
					Report
				</h5>
			</div>
			<div class="card-body pt-0">
				<div *ngIf="showReport">
					<button class="btn btn-success btn-sm ms-3 float-end my-1" (click)="downloadReport()"
						matTooltip="Download" [disabled]="downloadLoader">
						<fa-icon *ngIf="downloadLoader" [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
						<fa-icon *ngIf="!downloadLoader" [icon]="['fas','download']"></fa-icon>
						Download
					</button>
					<iframe class="pdf-container" [src]="fileURL" type="application/pdf"></iframe>
				</div>
			</div>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}
<div class="modal fade" id="otpModalReport" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<form [formGroup]="otpForm" (ngSubmit)="showOTP?verifyOTP():getOTP()">
				<div class="modal-header">
					<h4 class="modal-title"><strong>OTP Verification</strong></h4>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<h5>
								OTP Verification is required for editing notes
							</h5>
						</div>
					</div>
					<div class="row mb-2" *ngIf="!showOTP">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showOTPFormError('reason')}"
									id="reason" formControlName="reason" placeholder="">
								<label for="reason">Please enter reason for editing*</label>
							</div>
							<p *ngIf="showOTPFormError('reason')" class="text-danger">
								<span *ngIf="f1.reason.errors?.required">
									Required
								</span>
								<span *ngIf="f1.reason.errors?.incorrect">
									{{customErrorOTP.reason}}
								</span>
							</p>
						</div>
					</div>
					<div class="row mb-2" *ngIf="showOTP">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showOTPFormError('otp')}" id="otp"
									formControlName="otp" placeholder="">
								<label for="otp">OTP*</label>
							</div>
							<p *ngIf="showOTPFormError('otp')" class="text-danger">
								<span *ngIf="f1.otp.errors?.required">
									Required
								</span>
								<span *ngIf="f1.otp.errors?.incorrect">
									{{customErrorOTP.otp}}
								</span>
							</p>
							<p class="text-success">
								OTP sent to {{otpMailId}}
							</p>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success" [disabled]="otpFormLoader">
						<fa-icon *ngIf="otpFormLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						{{showOTP?"Verify OTP":"Send OTP"}}
					</button>
					<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>